<button class="sidebar-minimizer" type="button" appSidebarMinimizer appBrandMinimizer></button>



// WEBPACK FOOTER //
// /builds/sggd-10899/troca-senha-frontend/frontend/src/app/shared/layout/components/app-sidebar-minimizer/app-sidebar-minimizer.component.html